import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

import Topbar from "../components/Topbar";
import Sidebar from "../components/Sidebar";
import StorePerformanceCard from '../../../admin/components/report/StorePerformanceCard';

const StorePerformance = ({ token, client }) => {

    const history = useHistory();

    const [toggled, setToggled] = useState(false);

    useEffect(() => {
        if (!client || !client.store_performance) {
            history.push('/client')
        }
    }, [])

    const handleToggle = () => {
        setToggled(!toggled);
    }

    return (
        <div className="admin-page-container">
            <Sidebar toggled={toggled} setToggled={handleToggle} />
            <div className="admin-page">
                <Topbar handleToggle={handleToggle} />
                <div className="admin-content">
                    <StorePerformanceCard
                        role="client"
                        token={token}
                        operators={client.admin}
                        distributors={client.distributor}
                        outlets={client.outlet}
                    />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        client: state.client.client,
        token: state.client.token
    };
};

export default connect(mapStateToProps, null)(StorePerformance);